export const environment = {
  production: true,
  rootUrl: 'https://kt-store.com',
  s3: {
    bucketname: 'with-kt',
  },
};
